<template>
    <div class="home-page-main-body">
        <slide-cards-wrapper v-if="slideContainers.length" :slide-containers="slideContainers" />
        <span class="slide-filter-position" :class="{ hidden: !isShowFilter }">
            <slide-filter />
        </span>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import SlideCardsWrapper from './partials/SlideCardsWrapper'
import Utils from '../../business/utils/Utils'
import SlideFilter from './SlideFilter.vue'
import { SLIDE_TIME_ATTRIBUTION } from '../../business/const'

export default {
    name: 'HomePageMainBody',
    components: { SlideCardsWrapper, SlideFilter },
    data() {
        return { SLIDE_TIME_ATTRIBUTION }
    },
    computed: {
        ...mapState({
            instruments: state => state.timelapse.instruments,
            pastSlides: state => state.timelapse.pastSlides,
            homePageSelectedView: state => state.timelapse.homePageSelectedView,
            filterText: state => state.filter.filterText,
            filterDays: state => state.filter.filterDays,
            isShowFilter: state => state.filter.isShowFilter,
            patients: state => state.timelapse.patients
        }),
        filteredInstruments() {
            this.instruments.forEach(
                instrument => (instrument.filteredSlides = this.filterSlideCards(instrument.slides))
            )
            return this.instruments
        },
        slideContainers() {
            if (this.homePageSelectedView === SLIDE_TIME_ATTRIBUTION.ONGOING) {
                return this.filteredInstruments
            }
            return [{ filteredSlides: this.pastSlides }]
        }
    },
    methods: {
        filterPatient(slideCard) {
            const patient = this.patients.find(patient => patient._id === slideCard.patientId)
            if (patient) {
                return this.$utils
                    .getPatientEsIdByVendor(slideCard.instrumentType, patient)
                    .toLowerCase()
            }
            return ''
        },
        filterSlideCards(slideCards) {
            const filterTextLowerCase = this.filterText.toLowerCase()
            return slideCards.filter(card => {
                const cardLowerEsId = card.esId ? card.esId.toLowerCase() : ''
                const treatmentLowerEsId = card.treatmentEsId
                    ? card.treatmentEsId.toLowerCase()
                    : ''
                const patientLowerId = card.patientId ? this.filterPatient(card) : ''
                const fitsBySlideId = cardLowerEsId.includes(filterTextLowerCase)
                const fitsByTreatmentId = treatmentLowerEsId.includes(filterTextLowerCase)
                const fitsByPatientId = patientLowerId.includes(filterTextLowerCase)
                const fitsByDaysSinceFertilization =
                    !this.filterDays.length ||
                    this.filterDays.contains(
                        Utils.getDaysSinceFertilization(card.hoursSinceFertilization)
                    )
                return (
                    (fitsBySlideId || fitsByTreatmentId || fitsByPatientId) &&
                    fitsByDaysSinceFertilization
                )
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.home-page-main-body {
    position: relative;
    width: 100%;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    justify-content: center;

    .slide-filter-position {
        position: absolute;
        right: 0;
        width: 22rem;
        transition: 0.5s;
    }
    .hidden {
        right: -30%;
        @media screen and #{$new-break3} {
            display: none;
        }
        @media screen and #{$new-break2} {
            display: none;
        }
        @media screen and #{$new-break1} {
            display: none;
        }
    }
}
</style>
